import { Box, TableCell } from '@mui/material';
import { GridCellProps } from '@progress/kendo-react-grid';

import { useCompensationCellStyles } from './compensationCellStyles';

export const CompensationCell = ({ dataItem, rowType }: GridCellProps) => {
  const sxStyles = useCompensationCellStyles();
  const { compensation } = dataItem;

  if (!compensation || rowType !== 'data') {
    return null;
  }

  return (
    <TableCell sx={sxStyles.dataCell}>
      <Box sx={sxStyles.text}>
        {`${compensation.amount} ${
          compensation.currency ? compensation.currency : ''
        }`}
      </Box>
    </TableCell>
  );
};
